<template>
  <div class="content-box" :class="[{'service-list-page': title === '服务商列表'},{'idustry-list-page': title === '工业列表'} ]">
    <div class="page-title">{{title}}（{{total}}）</div>
    <!-- <a @click="addCompany" class="add-company" href="javascript:;"><i class="yjh-icon icon-add-company"></i><span>新增企业</span></a> -->
    <page-search
      :layout="searchLayout"
      @search="search"
    ></page-search>
    <pageTable
      class="yjh-iors-list"
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :titleRows="titleRows"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import Vue from 'vue'
import bus from '@/components/eventBus.js'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import hyCom from './components/hyCom'
import { addTitle } from '@/utils/common.js'
import { getIndustryList } from '@/api/userManager'
Vue.component('hyCom', hyCom)

export default {
  name: 'industryList',
  components: {
    pageSearch,
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      title: '工业列表',
      corpTypeKey: '', // 1 工业 2 服务商
      queryNo: '', // 搜索的企业编码
      queryName: '', // 搜索的企业名称
      queryTime: [], // 搜索的时间
      t_agent_info_agent_name: '', // 渠道名字
      searchLayout: ['code', 'name', 'regDate', 't_agent_info_agent_name'],
      titleColSpanLength: 1,
      col: [
        { field: 'operation', title: '操作', width: 120, titleAlign: 'left', columnAlign: 'left', componentName: 'operatea' },
        { field: 'cust_no', title: '企业编码', width: 90, titleAlign: 'left', columnAlign: 'left' },
        { field: 'company_type', title: '企业类型', width: 95, titleAlign: 'left', columnAlign: 'left' },
        { field: 'hy_level', title: '会员等级', width: 95, titleAlign: 'left', columnAlign: 'left', componentName: 'hyCom' },
        { field: 't_agent_info_agent_name', title: '渠道', width: 95, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'company_name', title: '企业名称', width: 220, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            return addTitle(rowData['company_name'])
          }
        },
        { field: 'company_domain', title: '企业域', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            return addTitle(rowData['company_domain'])
          }
        },
        { field: 'seller_name', title: '管理员', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'tel_no', title: '手机号码', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'service_rate', title: '服务费', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            return Number(rowData.service_rate * 100).toFixed(2) + '%'
          }
        },
        { field: 'type_desc', title: '类型', width: 60, titleAlign: 'left', columnAlign: 'left' },
        { field: 'use_date_desc', title: '有效期', width: 200, titleAlign: 'left', columnAlign: 'left' },
        { field: 'report_num', title: '剩余调研次数', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'live_site_url', title: '直播子域链接', width: 220, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            return addTitle(rowData['live_site_url'])
          }
        },
        { field: 'company_state_desc', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (rowData['company_state_desc'] === '使用中') {
              return '<span style="font-size:12px; color:#2BB968;">使用中</span>'
            } else if (rowData['company_state_desc'] === '已到期') {
              return '<span>已到期</span>'
            } else if (rowData['company_state_desc'] === '停用') {
              return '<span style="font-size:12px; color:#DE2F2F;">停用</span>'
            } else {
              return rowData['company_state_desc']
            }
          }
        },
        { field: 'credentialsChannel', title: '推送渠道', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (String(rowData['platform_flag']) === '0') {
              return '<span>天威</span>'
            } else if (String(rowData['platform_flag']) === '1') {
              return '<span>源天</span>'
            } else {
              return '<span>未绑定来源</span>'
            }
          }
        },
        { field: 'credentialsSearch', title: '证书选择', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (String(rowData['license_type']) === '0') {
              return '<span>UKEY</span>'
            } else if (String(rowData['license_type']) === '1') {
              return '<span>软证书</span>'
            } else {
              return '<span>未绑定类型</span>'
            }
          }
        },
        { field: 'max_account', title: '最大开通子账号数量', width: 180, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData, rowIndex, pageIndex, field) {
            return rowData[field] === '9999' ? '不限' : rowData[field]
          }
        },
        { field: 'volume', title: '容量空间', width: 95, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData, rowIndex, pageIndex, field) {
            return rowData[field] / 1000 + 'G'
          }
        },
        { field: 'login_num', title: '登录次数', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_tel', title: '联系电话', width: 120, titleAlign: 'left', columnAlign: 'left' },
        { field: 'create_time', title: '注册时间', width: 150, titleAlign: 'left', columnAlign: 'left' },
        { field: 'old_login_time', title: '最后登录时间', width: 150, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_social_credit_code', title: '统一社会信用代码', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_license', title: '营业执照注册号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_tax_registration', title: '税务登记号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_organization_code', title: '组织机构代码证', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_corp_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_passport_no', title: '护照', width: 140, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_corp_idcard', title: '身份证号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_certigier_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_certigier_idcard', title: '身份证号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_cell_phone', title: '手机', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_adm_email', title: '电子邮箱', width: 180, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            return addTitle(rowData['cay_adm_email'])
          }
        },
        { field: 'cay_receive_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (rowData['cay_receive_name']) {
              return addTitle(rowData['cay_receive_name'])
            } else {
              return ''
            }
          }
        },
        { field: 'cay_receive_address', title: '地址', width: 340, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (rowData['cay_receive_address']) {
              return addTitle(rowData['cay_receive_address'])
            } else {
              return ''
            }
          }
        },
        { field: 'cay_receive_tel', title: '电话', width: 110, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (rowData['cay_receive_tel']) {
              return rowData['cay_receive_tel']
            } else {
              return ''
            }
          }
        },
        { field: 'uk_no', title: '证书编号', width: 340, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (rowData['uk_no']) {
              return addTitle(rowData['uk_no'])
            } else {
              return ''
            }
          }
        },
        { field: 'platform_flag', title: '证书来源', width: 170, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            if (String(rowData['platform_flag']) === '0') {
              return '<span>天威</span>'
            } else if (String(rowData['platform_flag']) === '1') {
              return '<span>源天</span>'
            } else {
              return ''
            }
          }
        }
      ],
      titleRows: [
        [
          { fields: ['operation', 'cust_no', 'company_type', 'hy_level', 't_agent_info_agent_name', 'company_name', 'company_domain', 'seller_name', 'type_desc', 'use_date_desc', 'report_num', 'company_state_desc', 'credentialsChannel', 'credentialsSearch', 'max_account', 'volume', 'login_num', 'create_time', 'cay_tel', 'old_login_time'], title: '账号基本信息', titleAlign: 'center', colspan: 23 },
          { fields: ['cay_social_credit_code', 'cay_license', 'cay_tax_registration', 'cay_organization_code'], title: '企业基本信息', titleAlign: 'center', colspan: 4 },
          { fields: ['cay_corp_name', 'cay_passport_no', 'cay_corp_idcard'], title: '法定代表人或授权代表人信息', titleAlign: 'center', colspan: 3 },
          { fields: ['cay_certigier_name', 'cay_certigier_idcard', 'cay_cell_phone', 'cay_adm_email'], title: '授权管理员信息', titleAlign: 'center', colspan: 4 },
          { fields: ['cay_receive_name', 'cay_receive_address', 'cay_receive_tel', 'uk_no', 'platform_flag'], title: '收件人信息', titleAlign: 'center', colspan: 5 }
        ],
        [
          { fields: ['operation'], title: '操作', titleAlign: 'left' },
          { fields: ['cust_no'], title: '企业编码', titleAlign: 'left' },
          { fields: ['company_type'], title: '企业类型', titleAlign: 'left' },
          { fields: ['hy_level'], title: '会员等级', titleAlign: 'left' },
          { fields: ['t_agent_info_agent_name'], title: '渠道', titleAlign: 'left' },
          { fields: ['company_name'], title: '企业名称', titleAlign: 'left' },
          { fields: ['company_domain'], title: '企业域', titleAlign: 'left' },
          { fields: ['seller_name'], title: '管理员', titleAlign: 'left' },
          { fields: ['tel_no'], title: '手机号码', titleAlign: 'left' },
          { fields: ['service_rate'], title: '服务费', titleAlign: 'left' },
          { fields: ['type_desc'], title: '类型', titleAlign: 'left' },
          { fields: ['use_date_desc'], title: '有效期', titleAlign: 'left' },
          { fields: ['report_num'], title: '剩余调研次数', titleAlign: 'left' },
          { fields: ['live_site_url'], title: '直播子域链接', titleAlign: 'left' },
          { fields: ['company_state_desc'], title: '状态', titleAlign: 'left' },
          { fields: ['credentialsChannel'], title: '推送渠道', titleAlign: 'left' },
          { fields: ['credentialsSearch'], title: '证书选择', titleAlign: 'left' },
          { fields: ['max_account'], title: '最大开通子账号数量', titleAlign: 'left' },
          { fields: ['volume'], title: '容量空间', titleAlign: 'left' },
          { fields: ['login_num'], title: '登录次数', titleAlign: 'left' },
          { fields: ['cay_tel'], title: '联系电话', titleAlign: 'left' },

          { fields: ['create_time'], title: '注册时间', titleAlign: 'left' },
          { fields: ['old_login_time'], title: '最后登录时间', titleAlign: 'left' },
          { fields: ['cay_social_credit_code'], title: '统一社会信用代码', titleAlign: 'left' },
          { fields: ['cay_license'], title: '营业执照注册号', titleAlign: 'left' },
          { fields: ['cay_tax_registration'], title: '税务登记号', titleAlign: 'left' },
          { fields: ['cay_organization_code'], title: '组织机构代码证', titleAlign: 'left' },
          { fields: ['cay_corp_name'], title: '姓名', titleAlign: 'left' },
          { fields: ['cay_passport_no'], title: '护照', titleAlign: 'left' },
          { fields: ['cay_corp_idcard'], title: '身份证号', titleAlign: 'left' },
          { fields: ['cay_certigier_name'], title: '姓名', titleAlign: 'left' },
          { fields: ['cay_certigier_idcard'], title: '身份证号', titleAlign: 'left' },
          { fields: ['cay_cell_phone'], title: '手机', titleAlign: 'left' },
          { fields: ['cay_adm_email'], title: '电子邮箱', titleAlign: 'left' },
          { fields: ['cay_receive_name'], title: '姓名', titleAlign: 'left' },
          { fields: ['cay_receive_address'], title: '地址', titleAlign: 'left' },
          { fields: ['cay_receive_tel'], title: '电话', titleAlign: 'left' },
          { fields: ['uk_no'], title: '证书编号', titleAlign: 'left' },
          { fields: ['platform_flag'], title: '证书来源', titleAlign: 'left' }
        ]
      ]
    }
  },
  mounted() {
    document.querySelector('.v-table-body').addEventListener('scroll', this.scrollFun)
  },
  methods: {
    scrollFun() { // 页面滚动监听，将popover收起
      bus.$emit('hidePopFun')
    },
    // 初始化数据
    initPage() {
      this.title = this.$route.name === 'serverList' ? '服务商列表' : '工业列表'
      this.corpTypeKey = this.$route.name === 'serverList' ? 2 : 1
      this.queryNo = ''
      this.queryName = ''
      this.queryTime = []
      if (this.title === '工业列表' && this.col[9].field === 'service_rate') {
        const indTitleRow = { fields: ['operation', 'cust_no', 'company_type', 'hy_level', 't_agent_info_agent_name', 'company_name', 'company_domain', 'seller_name', 'tel_no', 'type_desc', 'use_date_desc', 'report_num', 'company_state_desc', 'credentialsChannel', 'credentialsSearch', 'max_account', 'volume', 'login_num', 'create_time', 'cay_tel', 'old_login_time'], title: '账号基本信息', titleAlign: 'center', colspan: 21 }
        this.titleRows[0].splice(0, 1, indTitleRow)
        this.col.splice(9, 1)
        this.col.splice(12, 1)
      } else if (this.title === '服务商列表' && this.col[8].field !== 'service_rate') {
        const serTitleRow = { fields: ['operation', 'cust_no', 'company_type', 'hy_level', 't_agent_info_agent_name', 'company_name', 'company_domain', 'seller_name', 'tel_no', 'service_rate', 'type_desc', 'use_date_desc', 'report_num', 'live_site_url', 'company_state_desc', 'credentialsChannel', 'credentialsSearch', 'max_account', 'volume', 'login_num', 'create_time', 'cay_tel', 'old_login_time'], title: '账号基本信息', titleAlign: 'center', colspan: 23 }
        const service_rate = { field: 'service_rate', title: '服务费', width: 100, titleAlign: 'left', columnAlign: 'left', formatter(rowData) { return Number(rowData.service_rate * 100).toFixed(2) + '%' } }
        const live_site_url = { field: 'live_site_url', title: '直播子域链接', width: 220, titleAlign: 'left', columnAlign: 'left', formatter(rowData) { return addTitle(rowData['live_site_url']) } }
        this.titleRows[0].splice(0, 1, serTitleRow)
        this.col.splice(9, 1, service_rate)
        this.col.splice(13, 1, live_site_url)
      }
    },
    addCompany() {
      const companType = this.$route.name === 'serverList' ? 'server' : 'industry'
      this.$router.push({ path: '/company/company-add-' + companType })
    },
    // 搜索的参数
    search(query) {
      this.initTable()
      this.queryNo = query.code || ''
      this.queryName = query.name || ''
      this.queryTime = query.regDate || []
      this.t_agent_info_agent_name = query.t_agent_info_agent_name || ''
      this.getData()
    },
    // 根据路由调用接口方法
    getData() {
      let query = {
        rp: this.pageSize,
        curpage: this.page
      }
      query = this.addQuery(query, 'corp_type_key', this.corpTypeKey)
      query = this.addQuery(query, 'cust_no', this.queryNo)
      query = this.addQuery(query, 'company_name', this.queryName)
      query = this.addQuery(query, 'register_time_start', this.queryTime[0])
      query = this.addQuery(query, 'register_time_end', this.queryTime[1])
      query = this.addQuery(query, 't_agent_info_agent_name', this.t_agent_info_agent_name)
      this.tableLoading = true
      getIndustryList(query).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          if (res.result === undefined || res.result === null || !Array.isArray(res.result.data)) {
            this.tableData = []
            this.total = 0
          } else {
            this.tableData = res.result.data
            this.total = res.result.count
          }
        }
      })
    }
  }
}
Vue.component('operatea', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    update() {
      const companType = this.$route.name === 'serverList' ? 'server' : 'industry'
      this.$router.push({ path: '/company/company-edit-' + companType + '/' + this.rowData.company_id })
    },

    list() {
      const companType = this.$route.name === 'serverList' ? 'server' : 'industry'
      this.$router.push({ path: '/detail/detail-list-' + companType + '/' + this.rowData.company_id })
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        operate: true
      }
    }, [h('a', {
      on: {
        click: this.list
      }
    }, '账号列表'), h('a', {
      on: {
        click: this.update
      }
    }, '编辑')])
  }
})
</script>
<style lang="scss">
  .idustry-list-page {
    .v-table-header {
      tr {
        &:first-child {
          td {
            border-right: 1px solid #D9E2EF;
            &:last-child {
              border-right: none;
            }
          }
        }
        &:nth-child(2) {
          td {
            &:nth-child(21),
            &:nth-child(25),
            &:nth-child(28),
            &:nth-child(32)
            {
              border-right: 1px solid #D9E2EF;
            }
          }
        }
      }
    }
    .v-table-body {
      tr {
        td {
            &:nth-child(21),
            &:nth-child(25),
            &:nth-child(28),
            &:nth-child(32)
          {
            border-right: 1px solid #D9E2EF;
          }
        }
      }
    }
  }
  // 服务商
  .service-list-page {
    .v-table-header {
      tr {
        &:first-child {
          td {
            border-right: 1px solid #D9E2EF;
            &:last-child {
              border-right: none;
            }
          }
        }
        &:nth-child(2) {
          td {
            &:nth-child(23),
            &:nth-child(27),
            &:nth-child(30),
            &:nth-child(34)
            {
              border-right: 1px solid #D9E2EF;
            }
          }
        }
      }
    }
    .v-table-body {
      tr {
        td {
            &:nth-child(23),
            &:nth-child(27),
            &:nth-child(30),
            &:nth-child(34)
          {
            border-right: 1px solid #D9E2EF;
          }
        }
      }
    }
  }
</style>
